import React from 'react'
import { connect } from 'react-redux'
import { change as changeFieldValue, reduxForm } from 'redux-form';
import Moment from 'react-moment';
import { withRouter } from 'react-router-dom';
import {
    getAdminEmpresa,
    getFiscalEmbarque,
    getGestorEmpresa,
    getMotoristaEmpresa,
    getOperadorEmpresa,
    PERFIL_ADMIN
} from '../../security/securityContext';
import Autorizacao from '../../security/Autorizacao';
import selecionarItinerario from '../../actions/itinerario/selecionarItinerario';
import { buscarReservasItinerario } from '../../actions/reserva/buscarReservasItinerario';
import selecionarRota from '../../actions/rota/selecionarRota';
import selecionarOrigem from '../../actions/origem/selecionarOrigem';
import selecionarDestino from '../../actions/destino/selecionarDestino';
import { listaTipoPrecos } from '../../util/constantsUtil';
import ReactTooltip from 'react-tooltip';

export class ItinerarioEncomenda extends React.Component {

    exibeAtivo = () => {
        return (
            <input type="checkbox" aria-readonly={true} data-target="#modalConfirmacaoInativacaoItinerario" value={this.props.itinerario.ativo} checked={this.props.itinerario.ativo} />
        );
    }

    exibirStatus() {
        if (this.props.itinerario.ativo) {
            return (<span aria-readonly={true} className="txt-ativo">Ativo</span>);
        }
        return (<span aria-readonly={true} className="txt-inativo">Inativo</span>);
    }

    exibeAtivoVendaSite = () => {
        return (
            <input type="checkbox" data-target="#modalConfirmacaoInativacaoVendaSite" value={this.props.itinerario.habilitadoSite} checked={this.props.itinerario.habilitadoSite} />
        );
    }

    exibirStatusVendaSite() {
        if (this.props.itinerario.habilitadoSite) {
            return (<span className="txt-ativo">Ativo</span>);
        }
        return (<span className="txt-inativo">Inativo</span>);
    }

    retornaPrecosItinerarioMisto(itinerario) {
        const poltronas = itinerario.poltronas;
        const tipoPrecos = [...new Set(poltronas.map(it => it.tipoPreco))];
        return tipoPrecos;
    }

    categoriasItinerario(itinerario) {
        const tipoPrecos = this.retornaPrecosItinerarioMisto(itinerario);
        let tipos = '';
        tipoPrecos.forEach((it, index) => {
            const item = listaTipoPrecos.filter(l => l.id == it);
            if (item && item.length > 0) {
                tipos += `${index > 0 ? ' | ' : ''} ${item[0].descricao}`
            }
        })
        return tipos

    }

    exibirIconeItinerarioMisto(itinerario) {
        return <> {this.props.itinerario.tipoCategoria} <span className="align-self-center tooltip-info">
            <a data-tip data-for={`categoria-${itinerario.id}`}>
                <i className="material-icons ajuda-icon" style={{ color: '#000' }}>&#xe147;</i>
            </a>
            <div className="tooltip-ut">
                <ReactTooltip className="tooltip-ut" id={`categoria-${itinerario.id}`}
                    type="dark" effect="solid">
                    <div className="row">{this.categoriasItinerario(itinerario)}</div>
                </ReactTooltip>
            </div>
        </span></>
    }

    render() {
        return (
            <div className="geral">
                <div className="resumo">
                    <div className="row">
                        <div className="col">
                            <span className="titulo-mobile">Data/Hora saída:&nbsp;</span>
                            <Moment
                                format="DD/MM/YYYY">{this.props.itinerario.dataPartida}</Moment> às {this.props.itinerario.horaSaida}
                        </div>
                        <div className="col">
                            <span
                                className="titulo-mobile">Assentos:&nbsp;</span>{this.props.itinerario.assentosDisponiveis}
                        </div>

                        <div className="col mr-md-n2">
                            <span
                                className="titulo-mobile">Veiculo:&nbsp;</span>{this.props.itinerario.veiculoDto.descricao}
                        </div>
                        <div className="col mr-md-4">
                            <span className="titulo-mobile">Rota:&nbsp;</span>
                            {this.props.itinerario.rotaDto.cidadeOrigem.nome}-
                            {this.props.itinerario.rotaDto.cidadeOrigem.uf} à {this.props.itinerario.rotaDto.cidadeDestino.nome}-
                            {this.props.itinerario.rotaDto.cidadeDestino.uf}
                        </div>
                        <div className="col mr-md-4">
                            <span className="titulo-mobile">Prestador:&nbsp;</span>
                            {this.props.itinerario.prestador ? this.props.itinerario.prestador.valor : 'Frota própria'}
                        </div>
                        <div className="col ml-md-n4 mr-2">
                            <div className="botoes">
                                <span className="titulo-mobile tm-status">Venda Site<br />Ativo/Inativo:&nbsp;</span>
                                <div aria-readonly={true} className="custom-btn-status exibeAtivo" htmlFor={this.props.itinerario.id}>
                                    {this.exibeAtivoVendaSite()}
                                    {this.exibirStatusVendaSite()}
                                </div>
                            </div>
                        </div>
                        <div className="col mr-md-3">
                            <div className="botoes">
                                <span className="titulo-mobile tm-status">Categorias<br />&nbsp;</span>
                                {this.props.itinerario.tipoPreco ? this.props.itinerario.tipoPreco.descricaoTipoPreco : this.exibirIconeItinerarioMisto(this.props.itinerario)}
                            </div>
                        </div>
                        <div className="col">
                            <div className="botoes">
                                <span className="titulo-mobile tm-status">Itinerário<br />ativo/inativo:&nbsp;</span>
                                <div aria-readonly={true} className="custom-btn-status exibeAtivo" htmlFor={this.props.itinerario.id}>
                                    {this.exibeAtivo()}
                                    {this.exibirStatus()}
                                </div>
                            </div>
                        </div>
                        <div id='container-botoes' className="col-sm-2 mr-md-n4">
                            <div className='dropdown'>
                                <span className="titulo-mobile">Ações:</span>
                                <button id='menu3pontos' className="btn btn-link btn-acoes btn-sm dropdown" type="button"
                                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    <i className="material-icons">
                                        &#xe5d4;
                                    </i>
                                </button>
                                <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                    <div className="botoes">
                                        <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
                                            getGestorEmpresa(this.props.empresaSelecionada.id),
                                            getAdminEmpresa(this.props.empresaSelecionada.id),
                                            getOperadorEmpresa(this.props.empresaSelecionada.id),
                                            getMotoristaEmpresa(this.props.empresaSelecionada.id),
                                            getFiscalEmbarque(this.props.empresaSelecionada.id)]}
                                            empresaSelecionada={this.props.empresaSelecionada}>
                                            <button type="button" className="btn ml-2"
                                                title='Buscar lista encomendas'
                                                onClick={() => {
                                                    this.props.history.push(`/painel-gerenciar-encomendas-itinerario?itinerario=${this.props.itinerario.id}`)
                                                }}>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-search" viewBox="0 0 16 16">
                                                    <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" />
                                                </svg>
                                            </button>
                                        </Autorizacao>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export function mapStateToProps(state) {
    return {
        empresaSelecionada: state.empresaSelecionada,
    }
}

export default withRouter(connect(mapStateToProps, {
    changeFieldValue,
    selecionarItinerario,
    buscarReservasItinerario,
    selecionarRota,
    selecionarOrigem,
    selecionarDestino,
})(reduxForm({
    form: 'formularioItinerario'
})(ItinerarioEncomenda)))
